<template>
  <div class="main">
    <div class="info-box">
        <table>
            <tr>
                <td class="title" colspan="2">
                    Streamdex League
                </td>
            </tr>
            <tr>
                <td class="logo">
                    <img src="../../assets/StreamdexLeague/ProfilePicture.png" alt="Streamdex League Logo">
                </td>
                <td>
                    Streamdex League is a video game played through Twitch by viewers<br>
                    In this colaborative game you can explore the Kanto region while trying to Catch 'em All!<br>
                    To follow its development you can visit the <a href="https://www.twitch.tv/streamdexleague">StreamdexLeague Twitch channel</a><br>
                    And/Or follow <a href="https://www.twitch.tv/simplyblg">SimplyBLG on Twitch</a>
                </td>
            </tr>
            <tr>
                <td class="header" colspan="2">
                    Available Commands
                </td>
            </tr>
            <tr><td class="command">!help</td><td>Links to this page</td></tr>
            <tr><td class="command">!choose (Pokémon)</td><td>Choose your starter Pokémon: Bulbasaur, Squirtle, or Charmander<br>This command is only available once per user</td></tr>
            <tr><td class="command">!play (Pokémon)</td><td>Send your Pokémon into battle!</td></tr>
            <tr><td class="command">!switch (Pokémon)</td><td>Switch your current active Pokémon with another one</td></tr>
            <tr><td class="command">!priority (attack/support/none)</td><td>Set the priority of your attacking Pokémon:<br>Attack - Prioritize offensive moves, do damage<br>Support - Prioritize Status moves, buff allies and debuff foes</td></tr>
            <tr><td class="command">!stats</td><td>View your current stats</td></tr>
            <tr><td class="command">!viewbox (box number)</td><td>View the Pokémon stored in your boxes</td></tr>
            <tr><td class="command">!vote (location)</td><td>Vote for the location we should move to next</td></tr>
            <tr><td class="command">!stop</td><td>Withdraw your Pokémon from the battle queue</td></tr>
            <tr><td class="command">!release (Pokémon)</td><td>Release a Pokémon in exchange for <i>Catch Points</i>, the more <i>Catch Points</i> you have the better your chances of catching wild Pokémon</td></tr>
            <tr><td class="command">!trade (user) (Pokémon)</td><td>Offer one of your Pokémon to another user, once both users accept the trade will be completed</td></tr>
            <tr><td class="command">!tradeaccept (user)</td><td>Accept the offered trade</td></tr>
            <tr><td class="command">!tradecancel (user)</td><td>Cancel the offered trade</td></tr>
            <tr>
                <td class="footer" colspan="2">
                    -
                </td>
            </tr>
        </table>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
      
    }
  }
</script>

<style scoped>
.main {
    max-width: 68rem; 
    margin: auto;
}
.info-box {
    margin: 4px;
    margin-top: 8px;
    padding: 4px;
    background-color: #39b331;
    border-radius: 1.5rem;
    color: whitesmoke;
}
.info-box .title {
    background-color: #2a7925;
    color: whitesmoke;
    font-weight: bold;
    padding: 4px;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    text-align: center;
}
.info-box .header {
    background-color: #2a7925;
    box-shadow: 1px 1px 5px -3px var(--box-shadow-color);
    --box-shadow-color: rgb(0, 0, 0, 0.75);
    border-radius: 3px;
    margin-bottom: 4px;
    font-weight: bold;
    text-align: center;
}
.info-box div {
    background-color: #328d2b;
    box-shadow: 1px 1px 5px -3px var(--box-shadow-color);
    --box-shadow-color: rgb(0, 0, 0, 0.75);
    border-radius: 3px;
    margin-bottom: 4px;
    margin-top: 4px;
}
.info-box .footer {
    background-color: #2a7925;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
    margin-bottom: 4px;
    color: transparent;
    user-select: none;
}
.info-box .logo {
    border-radius: 1rem;
    width: 256px;
    padding: 0;
}
.info-box .logo img {
    border-radius: 1rem;
    image-rendering: pixelated;
    width: 256px;
}
.info-box table {
    width: 100%;
    border-spacing: 4px;
    border-collapse: separate;
}
.info-box td {
    background-color: #328d2b;
    box-shadow: 1px 1px 5px -3px var(--box-shadow-color);
    --box-shadow-color: rgb(0, 0, 0, 0.75);
    border-radius: 3px;
    margin: 8px;
    text-align: left;
    padding: 4px;
}
.info-box a {
    color: rgb(70, 70, 212);
    text-decoration: underline;
}
.command {
    font-weight: bold;
}
</style>
